var _circle, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8StackCorrectly50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#1565c0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 4,
    x: 26,
    y: 32,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 4,
    x: 26,
    y: 26,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 4,
    x: 26,
    y: 20,
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 4,
    x: 26,
    y: 14,
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 4.001,
    x: 16.79,
    y: 9.337,
    fill: "#fff",
    transform: "rotate(-16.416 21.79 11.337)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 4.001,
    x: 12.539,
    y: 30.586,
    fill: "#fff",
    transform: "rotate(-16.416 17.54 32.588)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 10.015,
    height: 4,
    x: 8.366,
    y: 20.211,
    fill: "#fff",
    transform: "rotate(-51.423 13.373 22.21)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8StackCorrectly50);
export default __webpack_public_path__ + "static/media/icons8-stack-correctly-50.297dfc0c8b75eaf665281a65014a5d3f.svg";
export { ForwardRef as ReactComponent };